<template>
  <div>
    <PostSigning
      heading="Successful signing session"
      message="Lad Pirate Round yard rigging lugsail run a shot across the bow. Shiver me timbers maroon ye blow the man down."
      type="success"
      class="!h-auto"
    />
    <PostSigning
      heading="Buccaneer belaying pin Sea Legs"
      messageIntro="Chase guns holystone stern grog bucko jib American Main loaded to the gunwalls grapple main sheet."
      message="Draft coffer main sheet long boat hulk lee yawl trysail prow walk the plank."
      type="warning"
      class="!h-auto"
    />
    <PostSigning
      heading="Something went wrong"
      messageIntro="Tack Jolly Roger topsail reef sails strike colors pillage tackle squiffy interloper Arr."
      message="Provost jolly boat ho Admiral of the Black wherry jack splice the main brace barque Arr mizzenmast."
      type="error"
      class="!h-auto"
    />
    <PostSigning
      heading="Successful signing session"
      messageIntro="Chase guns holystone stern grog bucko jib American Main loaded to the gunwalls grapple main sheet."
      message="Provost jolly boat ho Admiral of the Black wherry jack splice the main brace barque Arr mizzenmast."
      type="success"
      class="!h-auto"
      :loading="true"
    />
    <PostSigning
      heading="Successful signing session"
      messageIntro="Lad Pirate Round yard rigging lugsail run a shot across the bow."
      message="Provost jolly boat ho Admiral of the Black wherry jack splice the main brace barque Arr mizzenmast."
      type="success"
      class="!h-auto"
      :loading="loading"
    />
    <PostSigning
      heading="Primary colour only."
      messageIntro="Chase guns holystone stern grog bucko jib American Main loaded to the gunwalls grapple main sheet."
      message="Draft coffer main sheet long boat hulk lee yawl trysail prow walk the plank."
      type="success"
      :branding="{
        colours: {
          primary: '#01534d',
        },
        logo: logoBs
      }"
      class="!h-auto pb-20"
    />
    <PostSigning
      heading="Both colours added in branding"
      message="Lad Pirate Round yard rigging lugsail run a shot across the bow. Shiver me timbers maroon ye blow the man down."
      type="success"
      :branding="{
        colours: {
          primary: '#f012be',
          accentPrimary: '#7E10C1',
          accentSecondary: '#ffffff'
        },
        logo
      }"
      class="!h-auto pb-20"
    />
    <PostSigning
      heading="Warning with brand colours"
      messageIntro="Chase guns holystone stern grog bucko jib American Main loaded to the gunwalls grapple main sheet."
      message="Draft coffer main sheet long boat hulk lee yawl trysail prow walk the plank."
      type="warning"
      :branding="{
        colours: {
          primary: '#f012be',
          accentPrimary: '#7E10C1',
          accentSecondary: '#ffffff'
        },
        logo: logoWide
      }"
      class="!h-auto pb-20"
    />
    <PostSigning
      heading="Logo has background :("
      message="Lad Pirate Round yard rigging lugsail run a shot across the bow. Shiver me timbers maroon ye blow the man down."
      type="success"
      :branding="{
        colours: {
          primary: '#851bfe',
          accentPrimary: '#cb6a15',
          accentSecondary: '#ffffff'
        },
        logo: logoBg
      }"
      class="!h-auto pb-20"
    />
    <PostSigning
      heading="White brand colour :("
      messageIntro="Tack Jolly Roger topsail reef sails strike colors pillage tackle squiffy interloper Arr."
      message="Provost jolly boat ho Admiral of the Black wherry jack splice the main brace barque Arr mizzenmast."
      type="success"
      :branding="{
        colours: {
          primary: '#ffffff',
          primaryIsWhite: true,
        },
        logo: logoBg
      }"
      class="!h-auto pb-20 border-0 border-t border-solid border-black"
    />
    <PostSigning
      heading="Looong looong logo"
      messageIntro="Tack Jolly Roger topsail reef sails strike colors pillage tackle squiffy interloper Arr."
      message="Provost jolly boat ho Admiral of the Black wherry jack splice the main brace barque Arr mizzenmast."
      type="success"
      :branding="{
        colours: {
          primary: '#333366',
          accentPrimary: '#ffff33',
          accentSecondary: '#444444'
        },
        logo: logoLong
      }"
      class="!h-auto pb-20"
    />
  </div>
</template>

<script setup>
import { ref } from 'vue'

import PostSigning from '@/components/screens/PostSigningScreen.vue'
import logo from '@/assets/designs/logo.png'
import logoWide from '@/assets/designs/logo-wide.png'
import logoBg from '@/assets/designs/logo-bg.png'
import logoBs from '@/assets/designs/logo-bs.png'
import logoLong from '@/assets/designs/logo-long.png'

const loading = ref(true)

setInterval(() => { loading.value = !loading.value }, 5000)
</script>
